import { render } from "./UserSkeleton.vue?vue&type=template&id=1774cd04"
import script from "./UserSkeleton.vue?vue&type=script&lang=js"
export * from "./UserSkeleton.vue?vue&type=script&lang=js"
script.render = render

export default script